import ModelDelete from "@/pages/modals/_delete";
import { useDeleteUserMutation } from "@/services/user.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteUser, {isSuccess}] = useDeleteUserMutation()

    const onAccept = () => {
        deleteUser(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_account")} content={t("modal.delete_account_content")} onAccept={onAccept} />
}